export default {
  data() {
    return {
      callReport115TableHeaders: [
        { text: 'ردیف', value: 'rowNumber', align: 'center', width: '100px' },
        { text: 'تاریخ', value: 'date', align: 'center', width: '130px' },
        { text: 'تلفن', value: 'phone', align: 'center', width: '130px' },
        {
          text: 'تشخیص احتمالی پرستار',
          value: 'cheifComplaint',
          align: 'center',
          width: '180px',
        },
        { text: 'توضیح', value: 'note', align: 'center', width: '250px' },
        { text: 'نتیجه', value: 'result', align: 'center', width: '100px' },
        {
          text: 'زمان تکمیل فرم',
          value: 'time',
          align: 'center',
          width: '150px',
        },
        { text: 'آدرس', value: 'address', align: 'center', width: '300px' },
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          width: '200px',
        },
        { text: 'حدود سن', value: 'age', align: 'center', width: '150px' },
        { text: 'کاربر', value: 'user', align: 'center', width: '200px' },
        {
          text: 'عملیات',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '100px',
        },
      ],
      callReport115List: [],
      searchTitle: '',
      listenVoicePermission: false,
      seePhoneNumberPermission: false,
      recordFile: null,
      player: false,
    };
  },
  methods: {
    callToPatient: function (number, tag = true, myMissionId = '') {
      if (number) {
        let data = {}
        if (tag) {
          data = {
            missionId: this.missionId,
            missionPhoneId: this.missionPhoneId,
            to: number,
          };
        } else {
          data = {
            missionId: myMissionId,
            to: number,
          }
        }
        this.callToPatientFunction(data);
      }
    },
    stopMusic: function () {
      const sound = this.$refs.audioFile;
      sound.pause();
      sound.currentTime = 0;
      this.player = false;
    },
  },
};
